import { Component, OnInit } from '@angular/core';
import { ServiceService } from '../service.service';
import { Router } from '@angular/router';
import * as moment from 'moment';

@Component({
  selector: 'app-sales-team',
  templateUrl: './sales-team.component.html',
  styleUrls: ['./sales-team.component.css']
})
export class SalesTeamComponent implements OnInit {

  constructor(
    private userService: ServiceService,
    private router: Router
  ) { }

  output: any = [];
  allData: any = [];
  ListId = "";
  ListName = "";
  currentPage = 0;
  hasNextPage = false;
  isLoading = true;
  isPaginationLoading = false;
  
  // Filter properties
  selectedMonth: string = '';
  
  // PrimeNG Calendar properties
  selectedDate: Date | null = new Date();
  formattedDate = '';

  // Computed property for active filters
  get hasActiveFilters(): boolean {
    return !!this.selectedMonth;
  }

  // Check if selected month is in the future
  get isFutureMonth(): boolean {
    if (!this.selectedMonth) return false;
    const selected = moment(this.selectedMonth + '-01');
    const now = moment().startOf('month');
    return selected.isAfter(now);
  }

  // 🎯 NEW: Debug method to check December data
  debugDecemberData() {
    console.log('=== DEBUG DECEMBER DATA ===');
    console.log('Selected Month:', this.selectedMonth);
    console.log('Selected Date:', this.selectedDate);
    console.log('All loaded teams:', this.output);
    
    // Check if any teams have December in their month field
    const decemberTeams = this.output.filter((team: any) => {
      return team.month && team.month.includes('December');
    });
    
    console.log('December teams found in current data:', decemberTeams);
    
    // Test API call directly for December 2025
    this.userService.ViewSalesTeam(0, '2025-12').subscribe({
      next: (res) => {
        console.log('DIRECT API CALL FOR DECEMBER 2025:', res);
        console.log('Data received:', res.data);
        console.log('Number of teams:', res.data?.length || 0);
        
        if (res.data && res.data.length > 0) {
          console.log('December teams from API:', res.data);
          // Check what's in the month field
          res.data.forEach((team: any, index: number) => {
            console.log(`Team ${index + 1}:`, {
              team_name: team.team_name,
              month: team.month,
              month_year: team.month_year
            });
          });
        }
      },
      error: (error) => {
        console.error('API Error:', error);
      }
    });
  }

  // Navigation methods
  btnClick() {
    this.router.navigate(['/admin/sales-team-creation']);
  }

  Details() {
    this.router.navigate(['/admin/sales-team-view']);
    this.scrollToTop();
  }

  EditDetails() {
    this.router.navigate(['/admin/sales-team-edit']);
    this.scrollToTop();
  }

  // Selection methods
  SetDepartment(Id: any, name: any) {
    this.ListId = Id;
    this.ListName = name;
  }

  // Delete method
  DeleteList() {
    if (!this.ListId) {
      this.userService.showToast('error', 'No team selected for deletion');
      return;
    }

    this.userService.DeleteSalesTeam(this.ListId).subscribe({
      next: (res) => {
        this.userService.showToast('success', res.message || 'Team deleted successfully!');
        this.loadSalesTeams(this.currentPage);
      },
      error: (error) => {
        console.error('Delete error:', error);
        this.userService.showToast('error', 'Error deleting team');
      }
    });
  }

  // Set team ID for navigation
  getValue = (item: string) => {
    this.userService.setSalesTeamId(item);
  }

  // Month filter methods - UPDATED
  onDateChange(date: Date) {
    console.log('🔍 Date selected:', date);
    
    if (!date) {
      this.clearMonthFilter();
      return;
    }
    
    const formatted = moment(date).format('YYYY-MM');
    this.formattedDate = formatted;
    this.selectedMonth = formatted;
    this.currentPage = 0;
    
    console.log('🔍 Filtering by month:', this.selectedMonth);
    
    this.loadSalesTeams(this.currentPage);
  }

  clearMonthFilter() {
    this.selectedMonth = '';
    this.selectedDate = null;
    this.formattedDate = '';
    this.currentPage = 0;
    console.log('🔍 Month filter cleared - showing all data');
    this.loadSalesTeams(this.currentPage);
  }

  clearAllFilters() {
    this.selectedMonth = '';
    this.selectedDate = null;
    this.formattedDate = '';
    this.currentPage = 0;
    this.loadSalesTeams(this.currentPage);
  }

  formatSelectedMonth(monthString: string): string {
    if (!monthString) return '';
    return moment(monthString + '-01').format('MMMM YYYY');
  }

  // Pagination methods
  clicks_previous() {
    if (this.currentPage > 0) {
      this.currentPage--;
      this.loadSalesTeams(this.currentPage);
    }
  }

  clicks_next() {
    if (this.hasNextPage) {
      this.currentPage++;
      this.loadSalesTeams(this.currentPage);
    }
  }

  // Main data loading method - UPDATED WITH DEBUG INFO
  private loadSalesTeams(page: number = 0) {
    this.isLoading = true;
    
    console.log('🔍 Loading sales teams with:', {
      page: page,
      selectedMonth: this.selectedMonth,
      formattedDate: this.formattedDate
    });

    this.userService.ViewSalesTeam(page, this.selectedMonth).subscribe({
      next: (res) => {
        console.log('🔍 API Response:', res);
        
        const itemsPerPage = 20;
        const currentItems = res.data || [];
        
        this.hasNextPage = currentItems.length === itemsPerPage;
        this.output = currentItems;
        
        console.log('🔍 Teams loaded:', this.output.length);
        
        // 🎯 Debug: Check what months are in the response
        if (this.output.length > 0) {
          const uniqueMonths = [...new Set(this.output.map((team: any) => team.month || team.month_year))];
          console.log('🔍 Unique months in response:', uniqueMonths);
        }
        
        this.isLoading = false;
        this.isPaginationLoading = false;
      },
      error: (error) => {
        console.error('🔍 Loading error:', error);
        this.isLoading = false;
        this.isPaginationLoading = false;
        this.output = [];
        
        if (page > 0) {
          this.currentPage--;
        }
      }
    });
  }

  private scrollToTop() {
    window.scrollTo(0, 0);
  }

  ngOnInit(): void {
    // Initialize with current month filter
    const currentMonth = moment().format('YYYY-MM');
    this.selectedMonth = currentMonth;
    this.formattedDate = currentMonth;
    console.log('🔍 Initializing with current month:', this.selectedMonth);
    this.loadSalesTeams(this.currentPage);
  }
}